export default __webpack_public_path__ + "static/media/no-data-found.425caf6a.gif";